import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { DEFAULT_BOX_API_BASE_URL, type BoxBaseUrls } from "@shared/utils/box";

type BoxState = {
  /** Undefined until resolved, and whenever the OEM is not proxied. */
  boxBaseUrls: BoxBaseUrls | undefined;
  setBoxBaseUrls: (boxBaseUrls: BoxBaseUrls | undefined) => void;
};

/**
 * Holds the Box base URLs for the signed-in OEM, so that components and plain
 * service functions alike can reach them without threading a parameter through
 * every call site. Hydrated once by `useSyncBoxBaseUrls` in the app layout,
 * off the `currentUser` that `useAuth` has already loaded there.
 */
export const useBoxStore = create<BoxState>()(
  devtools(
    (set) => ({
      boxBaseUrls: undefined,
      setBoxBaseUrls: (boxBaseUrls) => set({ boxBaseUrls }),
    }),
    { name: "BoxStore" },
  ),
);

/** Box API base for service functions that run outside React. */
export const getBoxApiBaseUrl = (): string =>
  useBoxStore.getState().boxBaseUrls?.baseUrl ?? DEFAULT_BOX_API_BASE_URL;
